import { setSelectedCategory } from "@/features/systemSlice";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
export default function ProductAutoComplete(prop) {
  const {
    handleOnChange,
    selectedValue,
    productOptions,
    multiple = false,
    error = false,
    fullWidth = false,
    selectByCategory = false,
    id,
    label = "產品",
    onClose = () => {},
  } = prop;
  const [searchText, setSearchText] = React.useState("");
  const inputRef = React.useRef(null);
  const [filterBrand, setFilterBrand] = React.useState(null);
  const productCategories = useSelector(
    (state) => state.system.productCategories,
    shallowEqual,
  );
  const [operator, setOperator] = React.useState("AND");
  const [showSelected, setShowSelected] = React.useState(false);
  const [includeSelectedCategory, setIncludeSelectedCategory] =
    React.useState(true);
  const [selectMode, setSelectMode] = React.useState("singleSelect");
  const location = useLocation();

  const { pathname } = location;

  const selectedCatgeory = useSelector(
    (state) => state.system.selectedCategory?.[pathname]?.[id] ?? [],
    shallowEqual,
  );
  const dispatch = useDispatch();

  const allBrand = _.chain(productOptions)
    .map((d) => {
      return {
        id: d.brand_id,
        brand_types_name: d.brand_name,
      };
    })
    .uniqBy("id")
    .sortBy("brand_types_name")
    .value();
  const filteredProduct = React.useMemo(() => {
    let products = [];
    if (selectByCategory) {
      const cloneProductOptions = _.clone(productOptions);
      if (!includeSelectedCategory) {
        products = cloneProductOptions;
      }
      const selectedProduct = _.remove(cloneProductOptions, (p) => {
        return (
          (filterBrand ? p.brand_id === filterBrand : true) &&
          (selectedCatgeory.length > 0
            ? (operator === "AND" &&
                _.intersection(p.categories, selectedCatgeory).length ===
                  selectedCatgeory.length) ||
              (operator === "OR" &&
                selectedCatgeory.length > 0 &&
                _.intersection(p.categories, selectedCatgeory).length >= 1)
            : true) &&
          (p?.m18_product_code
            ?.toLowerCase()
            .indexOf(searchText.toLowerCase()) > -1 ||
            p?.mannings_product_code?.indexOf(searchText) > -1 ||
            p?.product_name.toLowerCase()?.indexOf(searchText.toLowerCase()) >
              -1)
        );
      });
      products = selectedProduct;
    } else {
      products = _.filter(
        productOptions,
        (p) =>
          (filterBrand ? p.brand_id === filterBrand : true) &&
          (p?.m18_product_code
            .toLowerCase()
            ?.indexOf(searchText.toLowerCase()) > -1 ||
            p?.mannings_product_code?.indexOf(searchText) > -1 ||
            p?.product_name.toLowerCase()?.indexOf(searchText.toLowerCase()) >
              -1),
      );
    }
    if (showSelected) {
      products = _.filter(products, (p) => _.includes(selectedValue, p.id));
    }
    return products;
  }, [
    selectedCatgeory,
    searchText,
    filterBrand,
    multiple,
    productOptions,
    includeSelectedCategory,
    operator,
    showSelected,
  ]);
  const selectedValues = React.useMemo(() => {
    if (multiple) {
      return selectedValue;
    } else {
      return [selectedValue];
    }
  }, [selectedValue, multiple]);
  const isSelectedAll = React.useMemo(() => {
    return selectedValues.length === filteredProduct.length;
  }, [selectedValues, filteredProduct]);
  function makeItems(data) {
    const groupByBrand = _.groupBy(data, "brand_name");
    const items = [];
    _.forEach(groupByBrand, (values, brand) => {
      items.push(
        <ListSubheader style={{ zIndex: 0, width: 600 }} key={brand}>
          <IconButton
            onClick={(event) => {
              if (!multiple) return;
              let concatValue = [];
              const isExisting = data.find(
                (d) => d.brand_name === brand && selectedValues.includes(d.id),
              );
              if (isExisting) {
                const currentValues = productOptions.filter((options) =>
                  selectedValues.includes(options.product_master_id),
                );
                concatValue = _.map(
                  _.filter(currentValues, (d) => d.brand_name !== brand),
                  "product_master_id",
                );
              } else {
                const options = _.filter(
                  filteredProduct,
                  (p) => p.brand_name === brand,
                );

                concatValue = _.concat(
                  selectedValues,
                  _.map(options, "product_master_id"),
                );
              }
              setSelectMode("singleSelect");
              handleOnChange(concatValue);
              // handleSetFormData("promotion_shop", concatValue);
            }}
          >
            {brand}
            <ChecklistIcon color="success"></ChecklistIcon>
          </IconButton>
        </ListSubheader>,
      );
      _.forEach(values, (value) => {
        items.push(
          <MenuItem key={value.id} value={value.id}>
            <Checkbox checked={selectedValues.includes(value.id)} />
            {`${value.m18_product_code} - ${value.product_name}  ${
              value.region_id !== 1 ? `(${value.region_name})` : ""
            } 
            ${
              value.mannings_product_code !== undefined
                ? `(${value.mannings_product_code}) `
                : ""
            }
            `}
          </MenuItem>,
        );
      });
    });
    return items;
  }
  React.useEffect(() => {
    if (!selectByCategory || selectMode === "singleSelect") return;
    if (selectedCatgeory.length <= 0 && selectMode === "categroy") {
      handleOnChange([]);
      return;
    }

    if (selectedValues.length > 0 && selectedCatgeory.length <= 0) return;
    if (selectedCatgeory.length > 0) {
      const cloneProductOptions = _.clone(productOptions);

      const selectedProduct = _.remove(
        cloneProductOptions,
        (p) =>
          (operator === "AND" &&
            _.intersection(p.categories, selectedCatgeory).length ===
              selectedCatgeory.length) ||
          (operator === "OR" &&
            selectedCatgeory.length > 0 &&
            _.intersection(p.categories, selectedCatgeory).length >= 1 &&
            (filterBrand ? p.brand_id === filterBrand : true)),
      );

      if (includeSelectedCategory) {
        handleOnChange(_.map(selectedProduct, "product_master_id"));
      } else {
        handleOnChange(_.map(cloneProductOptions, "product_master_id"));
      }
    }
  }, [selectedCatgeory, includeSelectedCategory, operator]);
  return (
    <FormControl fullWidth={fullWidth} error={error}>
      <InputLabel id="brand-select-label">{label}</InputLabel>
      <Select
        {...prop}
        MenuProps={{ autoFocus: false }}
        labelId="product-select-label"
        id="product-select"
        value={selectedValues}
        multiple={multiple}
        onChange={(e) => {
          setSelectMode("singleSelect");
          handleOnChange(e.target.value);
        }}
        renderValue={(selected) => {
          if (!multiple) {
            return productOptions.find(
              (p) => p.product_master_id === selectedValue,
            )?.product_name;
          } else {
            return productOptions.length === selectedValues.length
              ? "所有產品"
              : `已選擇${selected.length}個`;
          }
        }}
        onClose={() => {
          setFilterBrand(null);
          setSearchText("");
          onClose();
        }}
        input={<OutlinedInput label="產品" />}
      >
        <ListSubheader
          style={{
            position: "sticky",
            minWidth: 600,
            top: 0,
            zIndex: 1,
          }}
        >
          {selectByCategory && (
            <React.Fragment>
              <FormControl sx={{ width: "25%", mt: 1 }}>
                <Select
                  fullWidth
                  labelId="includeSelectedCategory"
                  id="includeSelectedCategory"
                  label="包括?"
                  value={includeSelectedCategory}
                  onChange={(e, newValue) => {
                    setIncludeSelectedCategory(e.target.value);
                  }}
                >
                  <MenuItem value={true}>包括所選分類</MenuItem>
                  <MenuItem value={false}>不包括所選分類</MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{ width: "15%", mt: 1 }}>
                <Select
                  fullWidth
                  labelId="operator"
                  id="operator"
                  label="Operator"
                  value={operator}
                  onChange={(e, newValue) => {
                    setOperator(e.target.value);
                  }}
                >
                  <MenuItem value={"AND"}>AND</MenuItem>
                  <MenuItem value={"OR"}>OR</MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{ width: "60%", mt: 1 }}>
                <InputLabel id="demo-simple-select-label">
                  以分類選擇
                </InputLabel>
                <Select
                  fullWidth
                  labelId="category"
                  id="category"
                  label="以分類選擇"
                  multiple
                  value={selectedCatgeory}
                  renderValue={(selected) =>
                    selected.join(operator === "AND" ? " & " : " / ")
                  }
                  onChange={(e, newValue) => {
                    setSelectMode("categroy");
                    dispatch(
                      setSelectedCategory({
                        value: e.target.value,
                        id: id,
                        page: pathname,
                      }),
                    );
                  }}
                >
                  {productCategories.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </React.Fragment>
          )}
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel id="demo-simple-select-label">品牌篩選</InputLabel>
            <Select
              sx={{ width: "100%" }}
              labelId="brand"
              id="brand"
              label="品牌篩選"
              value={filterBrand}
              onChange={(e) => setFilterBrand(e.target.value)}
            >
              <MenuItem value="">
                <em>所有品牌</em>
              </MenuItem>
              {allBrand.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.id}>
                    {item.brand_types_name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <TextField
            sx={{ width: "100%", mt: 1 }}
            style={{
              backgroundColor: "white",
            }}
            autoFocus
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setSearchText("")}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            ref={inputRef}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                // Prevents autoselecting item while typing (default Select behaviour)
                e.stopPropagation();
              }
            }}
          />
          <FormControl fullWidth sx={{ mt: 1, alignItems: "center" }}>
            <Button
              onClick={() => {
                setShowSelected(!showSelected);
              }}
              variant={showSelected ? "outlined" : "contained"}
            >
              {showSelected ? "顯示所有" : "顯示已選擇"}
            </Button>
          </FormControl>
          {multiple && (
            <FormControl fullWidth sx={{ mt: 1, alignItems: "center" }}>
              <Button
                onClick={() => {
                  if (isSelectedAll || selectedValues.length > 0) {
                    handleOnChange([]);
                  } else {
                    handleOnChange(_.map(filteredProduct, "id"));
                  }
                }}
                variant={
                  isSelectedAll || selectedValues.length > 0
                    ? "contained"
                    : "outlined"
                }
              >
                {isSelectedAll || selectedValues.length > 0
                  ? "重設選擇"
                  : "選擇所有"}
              </Button>
            </FormControl>
          )}
        </ListSubheader>
        {makeItems(filteredProduct)}
      </Select>
      {error && <FormHelperText>請選擇產品</FormHelperText>}
    </FormControl>
  );
}
